import { PhoneCallIcon } from "lucide-react";
import type { Call } from "@/lib/api/calls";
import { formatDate, formatDuration } from "@/lib/utils";
import { CallRecordingControls } from "@/components/shared/call-recording-controls";

interface CallTimelineItemProps {
  call: Call;
}

export function CallTimelineItem({ call }: CallTimelineItemProps) {
  if (call.status === "scheduled") return null;

  const callCreator = call.fromUser?.name;
  const callDuration = formatDuration(call.duration);

  return (
    <div className="inline-flex w-full flex-col items-start justify-start gap-2.5 [&:not(:first-child)]:mt-4">
      <div className="inline-flex items-center justify-start gap-2.5 self-stretch">
        <div className="flex items-center justify-start gap-2.5">
          <div className="flex items-center justify-start gap-2.5 rounded bg-indigo-100">
            <div className="flex items-center justify-start gap-2.5 p-1">
              <PhoneCallIcon size={12} />
            </div>
          </div>
          <div className="text-xs font-normal text-stone-500">
            Call from {callCreator} on {formatDate(call.created_at)}
          </div>
        </div>
      </div>
      <div className="inline-flex items-start justify-start gap-2.5 self-stretch">
        <div className="flex w-4 items-start justify-start gap-2.5 self-stretch px-2">
          <div className="w-20 origin-top-left rotate-0 self-stretch border border-zinc-300"></div>
        </div>
        <div className="w-full rounded-md bg-white p-4">
          <div>Call duration: {callDuration}</div>
          <CallRecordingControls call={call} className="mt-1" />
        </div>
      </div>
    </div>
  );
}
